import {AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import * as feather from "feather-icons";
import {ListClaimsService} from "./services/list-claims.service";
import {DataTableDirective} from "angular-datatables";
import * as bootstrap from "bootstrap";
import {ClaimDto} from 'src/app/auto-generated-server-dtos/adjuster/list-claims/claim-dto';
import {ActivatedRoute} from '@angular/router';
import Utils from 'src/app/helpers/utils';
import {MulitSelectItem} from 'src/app/models/multiselectItem';
import AjaxSettings = DataTables.AjaxSettings;
import {ListClaimsResponse} from "../../../auto-generated-server-dtos/adjuster/list-claims/list-claims-response";

@Component({
  selector: 'app-claims-list',
  templateUrl: './claims-list.component.html',
  styleUrls: ['./claims-list.component.scss']
})
export class ClaimsListComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
  @ViewChild('claimsDataTable', { static: false }) claimsDataTable!: ElementRef;
  dtOptions: DataTables.Settings = {};
  errorOccurred = false;
  claims: ClaimDto[] = [];
  unresolvedClaims: ClaimDto[] = [];
  isLoading: boolean = true;

  claimStatusMultiselect: MulitSelectItem[] = [
    {
      id: 0,
      itemName: "Approved"
    },
    {
      id: 1,
      itemName: "Deleted"
    },
    {
      id: 2,
      itemName: "Draft"
    },
    {
      id: 3,
      itemName: "Pre-Approved"
    },
    {
      id: 4,
      itemName: "Rejected"
    },
    {
      id: 5,
      itemName: "Submitted"
    }
  ]
  claimStatusSelectedItems: MulitSelectItem[] = [];
  claimStatusMultiselectSettings = {};
  showSelfAssignedClaimsOnly = true;  

  private multiSelectStorageKey = "statusMultiSelect"
  private selfAssignedStorageKey = "showSelfAssignedClaimsOnly"

  constructor(
    private listClaimsService: ListClaimsService,
    private renderer: Renderer2,
    private route: ActivatedRoute, 
    private utils: Utils
  ) {
    this.renderer.addClass(document.body, 'adjuster');
    this.renderer.addClass(document.body, 'claim-list');
    this.renderer.removeClass(document.body, 'claim'); 
  }

  ngOnInit(): void {
    this.dtOptions = {
      serverSide: true,
      dom: '<"row mb-3"<"col-md-6"i><"col-md-6"f>><"row"<"px-0"t>><"row"<"col-6 mt-2"l><"col-6"p>>',
      language: {
        info: 'Showing _START_ to _END_ of _TOTAL_ claims',
        infoEmpty: 'Showing 0 claims',
        infoFiltered: '<br>Filtered from _MAX_ total claims',
        zeroRecords: 'No matching claims found',
        lengthMenu: 'Show _MENU_ claims',
      },
      lengthMenu: [
        [25, 50, 100, 250],
        [25, 50, 100, 250]
      ],
      pageLength: 25,
      order: [[2, 'desc']],
      stateSave: false,
      ajax: (ajaxSettings: AjaxSettings, callback) => {
        this.isLoading = true;
        this.listClaimsService.listClaims
        (
          ajaxSettings, this.showSelfAssignedClaimsOnly, this.getFilteredStatuses()
        ).subscribe({
            next: (resp: ListClaimsResponse) => {
              this.isLoading = false;
              this.claims = resp.claims;
              this.unresolvedClaims = this.claims;
              callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: resp.claims
                }
              )
            },
            error: () => {
              this.errorOccurred = true;
            }
          }
        );
      },
      columns: [
        {
          title: '',
          className: 'text-nowrap align-middle py-0 ps-3 pe-0',
          searchable: false,
          orderable: false,
          data: null,
          render: (data) => {
            if (
              data.claimsPortalClaimDuplicatesOnVehicleWithinTimeFrame.length
              || data.claimsPortalClaimDuplicatesOnWarrantyWithinTimeFrame.length
              || data.e2DuplicatesOnWarrantyWithinTimeFrame.length
              || data.e2DuplicatesOnVehicleWithinTimeFrame.length
            ) {
              return `
                <span class="text-danger" ngbTooltip="VIN found in another claim within 7 days">
                  <svg class="feather" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M5.75 1C6.16421 1 6.5 1.33579 6.5 1.75V3.6L8.22067 3.25587C9.8712 2.92576 11.5821 3.08284 13.1449 3.70797L13.3486 3.78943C14.9097 4.41389 16.628 4.53051 18.2592 4.1227C19.0165 3.93339 19.75 4.50613 19.75 5.28669V12.6537C19.75 13.298 19.3115 13.8596 18.6864 14.0159L18.472 14.0695C16.7024 14.5119 14.8385 14.3854 13.1449 13.708C11.5821 13.0828 9.8712 12.9258 8.22067 13.2559L6.5 13.6V21.75C6.5 22.1642 6.16421 22.5 5.75 22.5C5.33579 22.5 5 22.1642 5 21.75V1.75C5 1.33579 5.33579 1 5.75 1Z" />
                  </svg>
                </span>
              `;
            }
            return '';
          }
        }, {
          title: '',
          data: 'isNoTimelyResponseFromRepairCentre',
          className: 'text-nowrap align-middle p-0',
          searchable: false,
          orderable: false,
          render: (data) => {
            if (data) {
              return `
                <span class="text-warning" ngbTooltip="No reply within 48 hours">
                  <svg class="feather" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.5,18.7L14.1,2.8c-1-1.6-3.3-1.6-4.3,0L.5,18.7c-1,1.7.3,3.7,2.1,3.7h18.8c1.9,0,3.1-2,2.1-3.7ZM11.1,6.6h1.9c.6,0,1,.5,1,1l-.4,6.9c0,.5-.5.9-1,.9h-1.1c-.5,0-1-.4-1-.9l-.4-6.9c0-.6.4-1,1-1ZM12,20.4c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"/>
                  </svg>
                </span>
              `;
            }
            return '';
          }
        }, {
          title: 'Date',
          data: 'submittedDateTime',
          className: 'text-nowrap w-auto ps-3',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else {
              const date = new Date(data);
              const dateStr = date.toLocaleDateString("en-us", {weekday: "short", year: "numeric", month: "short", day: "numeric"});
              const timeStr = date.toLocaleTimeString("en-us", {hour12: true, hour: "numeric", minute: "2-digit"})
              return `<span class="text-nowrap">${dateStr}</span> <span class="text-nowrap">${timeStr}</span>`;
            }
          }
        },
        {
          title: 'Type',
          data: 'coverageType',
          className: 'text-nowrap',
          render: (data) => {
            return data;
          }
        }, {
          title: '<span class="text-nowrap">Repair Center</span>',
          data: 'repairCentreName',
          className: 'w-auto',
          render: (data) => {
            return data;
          }
        }, {
          title: 'User',
          data: 'submittedBy',
          className: 'w-auto',
          render: (data) => {
            return data.firstName + ' ' + data.lastName;
          }
        }, {
          title: 'Customer',
          data: 'customerName',
          className: 'w-auto'
        }, {
          title: 'VIN',
          data: 'vin'
        }, {
          title: 'Vehicle',
          data: 'ymmt',
          className: 'w-auto'
        }, {
          title: 'Status',
          data: 'status',
          render: (data) => {
            let statusClass = this.utils.renderStatusClass(data)
            return `<span class="badge bg-${statusClass}">${data}</span>`;
          }
        }, {
          title: 'Adjuster',
          data: 'assignedToName',
          render: (data) => {
            return data;
          }
        }, {
          title: '',
          data: '',
          searchable: false,
          orderable: false,
          className: 'text-end text-nowrap align-middle py-0 pe-3',
          render: (_data, _type, row) => {
            return `<a class="btn btn-link border-0 p-0 ms-2" href="/adjuster/claim/${row.claimId}" ngbTooltip="Edit"><i data-feather="edit-2"></i></a>`;
          }
        }
      ],
      drawCallback: function () {
        feather.replace();
      },
    };

    this.route.queryParams.subscribe(query => {
    const isUnresolvedClaims = query['unresolved'] === 'true';
      if (isUnresolvedClaims) {
        this.claimStatusSelectedItems = this.claimStatusMultiselect.filter(item => item.itemName == 'Submitted' || item.itemName == 'Pre-Approved');
        this.onClaimStatusMultiselectClose();
      }
    }).unsubscribe() 
    this.initializeLocaleStorage();
    this.claimStatusMultiselectSettings = {
      singleSelection: false, 
      text: "[Any Status]",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      classes: "form-multiselect",
    };
  }

  ngAfterViewChecked(): void {
    this.initializeTooltips();   
    this.initializeClaimStatusMultiselect();
  }
  
  ngOnDestroy() {
    this.datatableElement.dtTrigger.unsubscribe();
  }

  initializeTooltips(): void {
    if (!this.claimsDataTable?.nativeElement) {
      return;
    }

    const elements = this.claimsDataTable.nativeElement.querySelectorAll('[ngbTooltip]');
    elements.forEach((element: HTMLElement) => {
      if (!element.hasAttribute('tooltip-initialized')) {
        const tooltipText = element.getAttribute('ngbTooltip');
        this.renderer.setAttribute(element, 'title', tooltipText!);
        new bootstrap.Tooltip(element, {offset: [0, 0]});
        this.renderer.setAttribute(element, 'tooltip-initialized', '');
      }
    });
  }

  onClaimStatusMultiselectClose() {
    if (this.claimStatusSelectedItems.length == 0 || this.claimStatusSelectedItems.length == this.claimStatusMultiselect.length) {
      this.claimStatusSelectedItems = [...this.claimStatusMultiselect];
    } 
    localStorage.setItem(this.multiSelectStorageKey, JSON.stringify(this.claimStatusSelectedItems));
    this.refreshDataTable();
  }

  initializeClaimStatusMultiselect() {
    let selectedList = document.querySelector("div.c-list");
    let badges = selectedList?.querySelectorAll("div.c-token");
    let anyStatusDisplay = document.getElementById("AnyStatus");

    if (!badges) {
      return;
    }

    if (!anyStatusDisplay) {
      anyStatusDisplay = this.generateAnyStatusBadge();
      selectedList?.append(anyStatusDisplay);
    }

    const areAllClaimStatusesSelected = this.claimStatusSelectedItems.length === this.claimStatusMultiselect.length;

    this.styleGeneralBadges(areAllClaimStatusesSelected, badges);
    this.styleAnyStatusBadge(areAllClaimStatusesSelected, anyStatusDisplay);
  }

  generateAnyStatusBadge() {
    let anyStatusEl = document.createElement("div");
    anyStatusEl.id = "AnyStatus";
    anyStatusEl.textContent = "[Any Status]";
    return anyStatusEl;
  }

  styleAnyStatusBadge(allItemsSelected: boolean, anyStatusEl: HTMLElement) {
    if (!anyStatusEl) {
      return;
    }

    if (allItemsSelected) {
      anyStatusEl.className = "d-block";

    } else {
      anyStatusEl.className = "d-none";
    }
  }

  styleGeneralBadges(allItemsSelected: boolean, badges: NodeListOf<Element>) {
    if (allItemsSelected) {
      badges.forEach(badge => badge.className = "c-token d-none");
    } else {
      badges.forEach(badge => badge.className = `c-token d-block text-light bg-${this.utils.renderStatusClass(badge.textContent!)}`);
    }
  }

  getFilteredStatuses(): string[] {
    return this.claimStatusSelectedItems.map(item => item.itemName);
  }
  
  refreshDataTable() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload(() => {}, false);
    });
  }

  claimsFilterChanged() {
    localStorage.setItem(this.selfAssignedStorageKey, this.showSelfAssignedClaimsOnly.toString());

    if (this.showSelfAssignedClaimsOnly) {
      this.updateStatusItems(this.getDefaultStatusItems());
    }

    this.refreshDataTable();
  }
  
  private getDefaultStatusItems(): MulitSelectItem[] {
    return this.claimStatusMultiselect.filter(
      status => status.itemName === "Submitted" || status.itemName === "Pre-Approved"
    );
  }

  private updateStatusItems(items: MulitSelectItem[]) {
    this.claimStatusSelectedItems = items;
    localStorage.setItem(this.multiSelectStorageKey, JSON.stringify(items));
  }

  private initializeLocaleStorage() {
    const showSelfAssignedClaimsOnly = localStorage.getItem(this.selfAssignedStorageKey);
    const savedStatusFilter = localStorage.getItem(this.multiSelectStorageKey);

    this.showSelfAssignedClaimsOnly = showSelfAssignedClaimsOnly === null
      ? true
      : showSelfAssignedClaimsOnly === 'true';

    localStorage.setItem(this.selfAssignedStorageKey, this.showSelfAssignedClaimsOnly.toString());

    const statusItems = savedStatusFilter
      ? JSON.parse(savedStatusFilter)
      : this.getDefaultStatusItems();

    this.updateStatusItems(statusItems);
  }

}
